import React, { useState, useMemo, useEffect } from 'react'
import axios from 'axios'
import config from '../../../config'
import './Poll.css'
import { toast } from 'react-toastify'

const CheckmarkIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="20 6 9 17 4 12"></polyline>
  </svg>
)

const PollQuestion = ({
  question,
  options = [],
  pollID,
  MySubmission = null,
  onVoteSuccess
}) => {
  const [selectedOption, setSelectedOption] = useState(null)
  const [localOptions, setLocalOptions] = useState([])
  const [hasVoted, setHasVoted] = useState(false)

  
  const votedKey = `poll_voted_${pollID}`
  const choiceKey = `poll_choice_${pollID}`

  useEffect(() => {
    setLocalOptions(options)
  }, [options])

  useEffect(() => {
    const locallyVoted = localStorage.getItem(votedKey) === 'true'

    if (MySubmission) {
     
      const matched = options.find(opt => opt.label.trim() === MySubmission.trim())
      if (matched) {
        setSelectedOption(matched.optionId)
        setHasVoted(true)
        localStorage.setItem(votedKey, 'true')           
        localStorage.setItem(choiceKey, MySubmission)    
      }
    } else if (locallyVoted) {
     
      setHasVoted(true)
      const savedChoice = localStorage.getItem(choiceKey)
      if (savedChoice) {
        const matched = options.find(opt => opt.label.trim() === savedChoice.trim())
        if (matched) setSelectedOption(matched.optionId)
      }
    } else {
    
      setHasVoted(false)
      setSelectedOption(null)
      localStorage.removeItem(votedKey)
      localStorage.removeItem(choiceKey)
    }
  }, [MySubmission, options, pollID])

  const totalVotes = useMemo(() => {
    return localOptions.reduce((sum, o) => sum + (o.votes ?? 0), 0)
  }, [localOptions])

  const submitVote = async () => {
    if (selectedOption === null || hasVoted) return

    const selectedLabel = localOptions.find(o => o.optionId === selectedOption)?.label
    if (!selectedLabel) return toast.error('Invalid option')

    const token = localStorage.getItem('token')
    const payload = {
      PostID: pollID,
      Type: 'Vote',
      Data: { SelectedOption: selectedLabel }
    }

    try {
      await axios.post(`${config.apiUrl}/submissions/vote/submit`, payload, {
        headers: { Authorization: token, 'Content-Type': 'application/json' }
      })

     
      setHasVoted(true)
      setSelectedOption(selectedOption)

      
      localStorage.setItem(votedKey, 'true')
      localStorage.setItem(choiceKey, selectedLabel)

      toast.success('Vote submitted successfully!')

   
      if (onVoteSuccess) onVoteSuccess()

    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to submit vote')
      console.error(err)
    }
  }

  return (
    <div className="poll-container">
      <h3 className="poll-question">{question}</h3>

      <div className="poll-options">
        {localOptions.map(option => {
          const percentage =
            totalVotes > 0
              ? Math.round((option.votes / totalVotes) * 100)
              : 0

          return (
            <div key={option.optionId} className="poll-option-wrapper">
              {hasVoted ? (
                <>
                  <div className="result-info">
                    <span>{option.label}</span>
                    <span>{percentage}%</span>
                    {selectedOption === option.optionId && <CheckmarkIcon />}
                  </div>

                  <div className="progress-bar">
                    <div
                      className="progress"
                      style={{ width: `${percentage}%` }}
                    />
                  </div>

                  <div className="vote-count">{option.votes || 0} votes</div>
                </>
              ) : (
                <button
                  className={`poll-option ${
                    selectedOption === option.optionId ? 'selected' : ''
                  }`}
                  onClick={() => setSelectedOption(option.optionId)}
                >
                  {option.label}
                </button>
              )}
            </div>
          )
        })}
      </div>

      {!hasVoted && (
        <button
          className="vote-button"
          disabled={selectedOption === null}
          onClick={submitVote}
        >
          Vote
        </button>
      )}

      {hasVoted && (
        <div className="total-votes">Total votes: {totalVotes}</div>
      )}
    </div>
  )
}

export default PollQuestion